import { OtherUser } from '../../../user/services/tenant-user.service';

export const EXAMPLE_USERS: OtherUser[] = [
  {
    userId: 'sofia.martinez',
    emailAddress: 'sofia.martinez@starkcapital.com',
    blocked: false,
  },
  {
    userId: 'charlie.stark',
    emailAddress: 'charlie.stark@starkcapital.com',
    blocked: false,
  },
  {
    userId: 'lars.bjornsson',
    emailAddress: 'lars.bjornsson@starkcapital.com',
    blocked: false,
  },
];
